import React from "react";
import { Container, Typography } from "@material-ui/core";
import Footer from "../footer/Footer";
import CardProjects from "../shared/cardProjects/CardProjects";
import { ProjectsLogic, useStyles } from "./projects.module";
import BannerInterface from "../shared/bannerInterface/bannerInterface";
import bannerImg from "../../assets/images/bannerImg/forest_projects.webp";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";

const Projects = () => {
  const { translator } = ProjectsLogic();
  const classes = useStyles();
  const isMobile = useMediaQuery(useTheme().breakpoints.down("sm"));

  return (
    <>
      <BannerInterface
        backgroundImg={bannerImg}
        bannerTitle={[translator("projects.textBanner"), translator("")]}
        descriptionTexts={
          isMobile
            ? [translator("projects.subtitle")]
            : [
                translator("projects.subtitleOne"),
                translator("projects.subtitleTwo"),
                translator("projects.subtitleThree"),
              ]
        }
      />
      <Container>
        <div className={classes.flexContainer}>
          <Typography className={classes.textHeader}>
            {translator("projects.textHeader")}
          </Typography>
        </div>
        <CardProjects
          type={"Full"}
          text={translator("invest")}
          view={translator("projects.textView")}
          charging={translator("projects.charging")}
        />
      </Container>
      <Footer />
    </>
  );
};

export default Projects;
